{
  "name": "Name",
  "accountType": "Account Type",
  "portfolio": "Portfolio",
  "percentageOfTotalGOAL": "% of Total Goal",
  "percentageOfTotalACCOUNT": "% of Total Account",
  "balance": "Balance",
  "addSubAccount": "Add",
  "subAccount": "Sub-accounts",
  "noLinkedSubAccountToACCOUNT": "You do not have any sub-account linked to this Account",
  "noLinkedSubAccountToGOAL": "You do not have any sub-account linked to this Goal",
  "reactivateSubAccount": "Reactivate sub-account",
  "subAccountSuccessToast": "You have successfully re-activated this sub-account.",
  "closeSubaccountModal": {
    "title": "Close Sub-account",
    "body": "Are you sure you want to close this sub-account?",
    "close": "Close",
    "cancel": "Cancel"
  },
  "switchEquitiesModal": {
    "atCost": "Switch Security At Cost",
    "atMarket": "Switch Security At Market",
    "close": "Close",
    "cancel": "Cancel",
    "existingHolding": "Switch Out Security",
    "newHolding": "Switch In Security",
    "date": "Switch Date",
    "description": "Description",
    "switch": "Switch",
    "errorToastMessage": "Switch Transactions were not created.",
    "sameProductToastMessage": "Switch Out Security is the same as the Switch In Security."
  },
  "editSwitchEquitiesModal": {
    "atCostTransactionsTitle": "Switch Out / Switch In At Cost",
    "atMarketTransactionsTitle": "Switch Out / Switch In At Market",
    "subAccount": "Portfolio",
    "date": "Date",
    "switchOutSecurity": "Switch Out Security",
    "switchInSecurity": "Switch In Security",
    "quantity": "Total Number of Units",
    "cost": "Adjusted Cost Base per Unit",
    "totalCost": "Total Cost",
    "marketValuePerUnit": "Price per Unit",
    "marketValue": "Total Market Value",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "invalidPriceToastMessage": "Price cannot be $0."
  },
  "status": "Status",
  "Goal": "Goal",
  "Account": "Account",
  "recommended": "Recommended:",
  "close": "Close",
  "subaccountStateLabel": "Sub-account State",
  "owner": "Owner"
}
